import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import TwoCardsSection from '@/v2/components/sections/common/two-cards-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  forWhoSectionContent,
  HelperSectionContent,
  heroSectionContent,
  howToLabelYourLuggageSectionContent,
  howToMeasureWeightAndDimensionsSectionContent,
  TwoCardsSectionContent,
  whyChooseUsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/luggage-shipping-page'

interface LuggageShippingPageProps {}

const LuggageShippingPage: React.FC<LuggageShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[350px] h-[197px] 
        lg:!w-[464px] lg:!h-[261px] 
        xl-min:!w-[700px] xl-min:!h-[458px]
      '
        btnClassName='xl-min:!w-[269px] xl-min:h-[50px] md-mn:w-[240px] w-[278px] h-[44px]'
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} />
      <HelperSection
        isInverted
        {...HelperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] lg-mn:w-[440px] lg-mn:h-[276px] md-mn:w-[354px] md-mn:h-[222px] w-[354px] h-[222px]'
        sectionTitleClassName='xl-min:!w-full w-[90%]'
      />
      <TwoCardsSection isBgDark {...TwoCardsSectionContent} />
      <HelperSection
        {...howToLabelYourLuggageSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[330px] md-mn:h-[206px] w-[330px] h-[206px]'
      />
      <HelperSection
        isBgDark
        {...howToMeasureWeightAndDimensionsSectionContent}
        className='[&_ul]:space-y-2'
        imgClassName='xl-min:!w-[657px] xl-min:!h-[344px] md-mn:w-[350px] md-mn:h-[183px] w-[350px] h-[183px]'
      />
      <WhyWeSection
        {...whyChooseUsSectionContent}
        className={`
        [&_article]:bg-transparent
        [&_article]:border-none
        xl-min:[&_button]:!w-[290px]
        lg-mn:[&_button]:w-[274px]
        md-mn:[&_button]:w-[264px]
        [&_button]:w-[298px]
        `}
      />
      <ForWhoSection isBgDark {...forWhoSectionContent} className='md-mn:[&>div>div:nth-of-type(2)]:gap-x-3' />
      <FaqSection {...faqSectionContent} />
    </>
  )
}

export default LuggageShippingPage
